module.exports = __webpack_public_path__ + "img/login-bottom.b9cbf788.png";